import { useState } from "react";

const QA_ITEMS = [
  {
    q: "What does Lemon Protector do?",
    a: "Lemon Protector provides professional pre-purchase used car inspections across New York, New Jersey, and Connecticut. We travel on-site to the vehicle's location and perform a comprehensive 450-point bumper-to-bumper inspection — covering mechanical systems, electrical, body, chassis, and more. You also get a free title and vehicle history report, plus a direct phone consultation with the actual inspector who evaluated the car.",
  },
  {
    q: "What is included in a 450-point inspection?",
    a: "Our 450-point inspection covers the entire vehicle: engine condition, transmission, brakes, suspension, steering, electrical systems, A/C and heat, body and paint, interior, undercarriage, and a full test drive. We also check for evidence of prior accidents, flood damage, and odometer tampering. Every inspection includes a detailed written report with photos and a free book value appraisal.",
  },
  {
    q: "Who should get a pre-purchase car inspection?",
    a: "Anyone buying a used car should get an independent inspection. Whether you're buying from a private seller, a used car dealership, or purchasing out-of-state, a Lemon Protector inspection gives you the unbiased facts you need to negotiate confidently and avoid costly surprises after purchase.",
  },
  {
    q: "Why is Lemon Protector different from CARFAX or a mechanic?",
    a: "CARFAX only reports what's been filed in databases — it cannot tell you about unreported accidents, mechanical wear, or hidden damage. Mechanics focus on repairs, not evaluations, and may have a conflict of interest. Lemon Protector specializes exclusively in pre-purchase inspections. We have no incentive other than giving you accurate, complete information.",
  },
];

export default function AIAnswerBlock() {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);

  return (
    <section className="bg-brand-panel py-24 lg:py-32">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row gap-16">
          {/* Left */}
          <div className="lg:w-1/3">
            <p className="font-sans text-xs tracking-widest uppercase text-brand-gold mb-4 flex items-center gap-3">
              <span className="w-8 h-px bg-brand-gold" />
              Quick Answers
            </p>
            <h2 className="font-serif text-3xl lg:text-4xl font-semibold text-brand-white leading-tight mb-5">
              Everything You Need to Know About Pre-Purchase Inspections
            </h2>
            <p className="font-sans text-sm text-brand-gray leading-relaxed">
              We answer the questions every smart used-car buyer should ask before handing over any money.
            </p>
            <div className="mt-10 font-serif text-[110px] leading-none text-brand-gold/8 select-none">&ldquo;</div>
          </div>

          {/* Right Q&A Accordion */}
          <div className="lg:w-2/3 flex flex-col gap-4">
            {QA_ITEMS.map((item, i) => (
              <div
                key={i}
                className={`rounded-2xl border transition-all duration-300 overflow-hidden ${
                  activeIndex === i
                    ? "border-brand-gold/40 bg-brand-charcoal"
                    : "border-brand-gold/10 bg-brand-charcoal/50 hover:border-brand-gold/25"
                }`}
              >
                <button
                  className="w-full text-left px-6 py-5 flex items-start justify-between gap-4 cursor-pointer"
                  onClick={() => setActiveIndex(activeIndex === i ? null : i)}
                >
                  <h3 className="font-serif text-base text-brand-white font-medium leading-snug">
                    {item.q}
                  </h3>
                  <div className="w-7 h-7 flex items-center justify-center shrink-0 mt-0.5">
                    <i
                      className={`text-brand-gold text-lg transition-transform duration-300 ${
                        activeIndex === i ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    />
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    activeIndex === i ? "max-h-60 pb-6" : "max-h-0"
                  }`}
                >
                  <p className="px-6 font-sans text-sm text-brand-gray-light leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
